// constants
const RAINFALL = "scenarioOne/RAINFALL";
const SLR = "scenarioOne/SLR";
const SURGE = "scenarioOne/SURGE";
const GROUNDWATER = "scenarioOne/GROUNDWATER";
const ADAPTATION = "scenarioOne/ADAPTATION";

// actions
const getRain = (option) => {
 return {
  type: RAINFALL,
  option,
 };
};

const getSLR = (option) => {
 return {
  type: SLR,
  option,
 };
};

const getSurge = (option) => {
 return {
  type: SURGE,
  option,
 };
};

const getGroundwater = (option) => {
 return {
  type: GROUNDWATER,
  option,
 };
};

const getAdaptation = (option) => {
 return {
  type: ADAPTATION,
  option,
 };
};

// thunks
export const getRainfallAmount = (option) => async (dispatch) => {
 try {
  dispatch(getRain(option));
 } catch (error) {
  return error.message;
 }
};
export const getSeaLevelRise = (option) => async (dispatch) => {
 try {
  dispatch(getSLR(option));
 } catch (error) {
  return error.message;
 }
};
export const getStormSurge = (option) => async (dispatch) => {
 try {
  dispatch(getSurge(option));
 } catch (error) {
  return error.message;
 }
};
export const getGroundwaterCondition = (option) => async (dispatch) => {
 try {
  dispatch(getGroundwater(option));
 } catch (error) {
  return error.message;
 }
};
export const getAdaptationScenario = (option) => async (dispatch) => {
 try {
  dispatch(getAdaptation(option));
 } catch (error) {
  return error.message;
 }
};

// initial state
const initialState = {
 scenarioOne: {},
};

// reducer
const scenarioOneReducer = (state = initialState, action) => {
 let newState;
 switch (action.type) {
  case ADAPTATION:
   newState = { ...state };
   newState.scenarioOne["adaptation"] = {};
   newState.scenarioOne["adaptation"] = action.option;
   if (!!newState.scenarioOne["slr"]) delete newState.scenarioOne["slr"];
   if (!!newState.scenarioOne["rainfall"])
    delete newState.scenarioOne["rainfall"];
   if (newState.scenarioOne["surge"]) delete newState.scenarioOne["surge"];
   if (newState.scenarioOne["groundwater"])
    delete newState.scenarioOne["groundwater"];
   return newState;
  case SLR:
   newState = { ...state };
   newState.scenarioOne["slr"] = {};
   newState.scenarioOne["slr"] = action.option;
   if (!!newState.scenarioOne["rainfall"])
    delete newState.scenarioOne["rainfall"];
   if (newState.scenarioOne["surge"]) delete newState.scenarioOne["surge"];
   if (newState.scenarioOne["groundwater"])
    delete newState.scenarioOne["groundwater"];
   return newState;
  case RAINFALL:
   newState = { ...state };
   newState.scenarioOne["rainfall"] = {};
   newState.scenarioOne["rainfall"] = action.option;
   if (!!newState.scenarioOne["surge"]) delete newState.scenarioOne["surge"];
   if (!!newState.scenarioOne["groundwater"])
    delete newState.scenarioOne["groundwater"];
   return newState;
  case SURGE:
   newState = { ...state };
   newState.scenarioOne["surge"] = {};
   newState.scenarioOne["surge"] = action.option;
   if (newState.scenarioOne["groundwater"])
    delete newState.scenarioOne["groundwater"];
   return newState;
  case GROUNDWATER:
   newState = { ...state };
   newState.scenarioOne["groundwater"] = {};
   newState.scenarioOne["groundwater"] = action.option;
   return newState;
  // case ADAPTATION:
  //  newState = { ...state };
  //  newState.scenarioOne["adaptation"] = {};
  //  newState.scenarioOne["adaptation"] = action.option;
  //  return newState;
  default:
   return state;
 }
};

export default scenarioOneReducer;
